import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

import u from './Utilities';


if(process.env.REACT_APP_MODE == "development") {
    console.error("PRELOADED TEST WORDPRESS USER: DO NOT USE THIS FOR PRODUCTION");
    u.preloadTestUser();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);